import { Reducer } from "redux";
import * as actions from "./userTermActions";
import produce from "immer";
import { UserTerm } from "../../service/api-response/UserTermSuccessResponse";
import { UserTermListItem } from "../../service/api-response/UserTermListSuccessResponse";

export interface UserTermState {
  userTerms: {
    [org: string]: UserTermListItem[];
  };
  isLoadingUserTerms: {
    [org: string]: boolean;
  };
  userTermVersions: {
    [organization: string]: {
      [id: string]: any[];
    };
  };
  isLoadingUserTermVersions: {
    [org: string]: {
      [id: string]: boolean;
    };
  };
  userTerm: {
    [org: string]: {
      [id: string]: UserTerm;
    };
  };
  userTermVersion: {
    [org: string]: {
      [id: string]: any;
    };
  };
}

const initialState: UserTermState = {
  userTerms: {},
  isLoadingUserTerms: {},
  userTermVersions: {},
  isLoadingUserTermVersions: {},
  userTerm: {},
  userTermVersion: {},
};

type SupportedActions =
  | actions.DeleteUserTermAction
  | actions.DeleteUserTermFailAction
  | actions.DeleteUserTermSuccessAction
  | actions.DeleteUserTermVersionAction
  | actions.DeleteUserTermVersionFailAction
  | actions.DeleteUserTermVersionSuccessAction
  | actions.GetUserTermAction
  | actions.GetUserTermFailAction
  | actions.GetUserTermSuccessAction
  | actions.GetUserTermVersionAction
  | actions.GetUserTermVersionFailAction
  | actions.GetUserTermVersionSuccessAction
  | actions.GetUserTermListAction
  | actions.GetUserTermListFailAction
  | actions.GetUserTermListSuccessAction
  | actions.GetUserTermVersionListAction
  | actions.GetUserTermVersionListSuccessAction
  | actions.GetUserTermVersionListFailAction
  | actions.UpsertUserTermAction
  | actions.UpsertUserTermFailAction
  | actions.UpsertUserTermSuccessAction
  | actions.UpsertUserTermVersionAction
  | actions.UpsertUserTermVersionFailAction
  | actions.UpsertUserTermVersionSuccessAction;

export const userTermReducer: Reducer<UserTermState, SupportedActions> = (
  state = initialState,
  action
) => {
  return produce(state, (draftState) => {
    draftState.userTermVersions[action.organization] =
      draftState.userTermVersions[action.organization] || {};
    draftState.isLoadingUserTermVersions[action.organization] =
      draftState.isLoadingUserTermVersions[action.organization] || {};
    draftState.userTerm[action.organization] =
      draftState.userTerm[action.organization] || {};
    draftState.userTermVersion[action.organization] =
      draftState.userTermVersion[action.organization] || {};

    switch (action.type) {
      case actions.GET_USER_TERM_LIST: {
        delete draftState.userTerms[action.organization];
        draftState.isLoadingUserTerms[action.organization] = true;
        break;
      }
      case actions.GET_USER_TERM_LIST_FAIL: {
        draftState.isLoadingUserTerms[action.organization] = false;
        break;
      }
      case actions.GET_USER_TERM_LIST_SUCCESS: {
        draftState.isLoadingUserTerms[action.organization] = false;
        draftState.userTerms[action.organization] = action.data;
        break;
      }
      case actions.GET_USER_TERM_VERSION_LIST: {
        delete draftState.userTermVersions[action.organization][
          action.userTermId
        ];
        draftState.isLoadingUserTermVersions[action.organization][
          action.userTermId
        ] = true;

        break;
      }
      case actions.GET_USER_TERM_VERSION_LIST_FAIL: {
        draftState.isLoadingUserTermVersions[action.organization][
          action.userTermId
        ] = false;
        break;
      }
      case actions.GET_USER_TERM_VERSION_LIST_SUCCESS: {
        draftState.isLoadingUserTermVersions[action.organization][
          action.userTermId
        ] = false;
        draftState.userTermVersions[action.organization][action.userTermId] =
          action.data;

        break;
      }
      case actions.GET_USER_TERM_SUCCESS: {
        draftState.userTerm[action.organization][action.userTermId] =
          action.data;

        break;
      }
      case actions.GET_USER_TERM_VERSION_SUCCESS: {
        draftState.userTermVersion[action.organization][
          action.userTermVersionId
        ] = action.data;

        break;
      }
      default: {
        return;
      }
    }
  });
};
